const ptPT = {
  tours: {
    pkg1: {
      price: "€790",
      title: "Escapadinha de fim de semana de luxo na Europa/Marrocos",
      duration: "3 Noites / 4 Dias ",
      hl1: "Voos diretos de ida e volta incluídos (Londres/Europa)",
      hl2: "Hotéis de luxo de 4 a 5 estrelas",
      hl3: "Hammam marroquino tradicional",
      hl4: "Oficinas de culinária e arte",
      hl5: "Apresentações ao vivo marroquinas",
      hl1_brief: "Voos diretos de ida e volta incluídos",
      subtitle: "Pacote Tudo Incluído – De A a Z",
      flight1: "Voos diretos de ida e volta",
      flight2: "Bagagem despachada de 20kg",
      flight3: "Bagagem de cabine até 8kg",
      inc1: "Recolha no aeroporto e transferência de volta",
      inc2: "Hotéis de 4 a 5 estrelas (meia pensão)",
      inc3: "Cozinha marroquina fresca e autêntica",
      inc4: "Experiência tradicional de chá e doces",
      inc5: "Guia turístico profissional e motorista particular",
      inc6: "Transporte moderno com ar condicionado",
      inc7: "Apresentações especiais ao vivo (cantores e dançarinos)",
      inc7_brief: "Apresentações especiais ao vivo",
      inc8: "Passeios tradicionais de mercado (especiarias, lanterna, tapete)",
      inc8_brief: "Passeios de mercado tradicionais",
      inc9: "Oficinas de culinária e arte (é necessária reserva prévia)",
      inc9_brief: "Oficinas de culinária e arte",
      inc10: "Visitas a nascentes naturais e miradouros",
      inc11: "Viagens de um dia para Chefchaouen e Ifrane",
      inc12: "Visitas com famílias marroquinas locais",
      inc13: "Experiências surpresa durante o passeio",
      suit1: "Casais",
      suit2: "Famílias",
      suit3: "Grupos",
      suit4: "Viajantes individuais",
      suit5: "Idosos",
      suit6: "Empresas",
      suit7: "Agências de viagens",
      suit8: "Operadores turísticos"
    },
    pkg2: {
      price: "€1490",
      title: "Excursão de descoberta de luxo em Marrocos",
      duration: "6 Noites / 7 Dias ",
      hl1: "Pacote A",
      hl2: "Movimentos Atlas",
      hl3: "Marakech- Essaouira - Merzouga - Ouarzazte - Marakech-",
      hl4: "Grande surpresa ❤️",
      hl5: "Pacote B",
      subtitle: "Rota Fez e Norte de Marrocos (tudo incluído)",
      routeText: "2 noites Fes, 1 noite Chefchaouen, 1 noite Tânger, 1 noite Ifrane, 1 noite final Fes",
      flight1: "Voos diretos de ida e volta da Europa",
      flight2: "Bagagem de 20kg + bagagem de cabine",
      trans1: "Recolha e transferência no aeroporto",
      trans2: "Motorista profissional particular e guia turístico",
      trans3: "Novos veículos com ar condicionado",
      hotel1: "Hotéis de 4 a 5 estrelas",
      hotel2: "Locais premium",
      hotel3: "Serviço de alto nível",
      food1: "Meia pensão",
      food2: "Cozinha autêntica",
      food3: "Chá e doces tradicionais",
      exp1: "Apresentações ao vivo marroquinas",
      exp2: "Mercados tradicionais (Especiarias, Lanterna, Tapete)",
      exp2_brief: "Mercados tradicionais",
      exp3: "Hammam marroquino tradicional",
      exp4: "Visitas à natureza e à floresta",
      exp4_brief: "Visitas à natureza",
      exp5: "Belos mirantes e passeios de um dia",
      exp6: "Oficinas de culinária e arte",
      exp7: "Visitas com famílias locais",
      exp8: "Surpresas especiais durante a viagem",
      suit1: "Casais",
      suit2: "Famílias",
      suit3: "Grupos",
      suit4: "Viajantes individuais",
      suit5: "Idosos",
      suit6: "Empresas",
      suit7: "Agências de viagens"
    },
    pkg3: {
      price: "€1990",
      title: "Grande Experiência em Marrocos",
      duration: "10 noites / 11 dias ",
      hl1: "Serviços terrestres premium completos",
      hl2: "Casablanca, Marraquexe e Fez",
      hl3: "Surpresas no deserto de Agadir e Saara",
      hl4: "Visite Ouarzazate e Chefchaouen",
      hl5: "Música e apresentações especiais ao vivo",
      subtitle: "✨ Marrocos Grand Experience (somente serviços terrestres)",
      arrivalText: "Casablanca ou Marraquexe",
      routeText: "Casablanca, Rabat, 2 noites Fez, Tânger, Chefchaouen, Ifrane, 2 noites Marrakech, Agadir, Ouarzazate, última noite Marrakech",
      note2: "Grupos > 40: Desconto especial de $50 por pessoa",
      note3: "Voos internacionais e seguros NÃO incluídos",
      note4: "Gorjetas para motorista/guia NÃO incluídas",
      inc1: "Serviços terrestres premium completos",
      inc2: "Hotéis de 4 a 5 estrelas (meia pensão)",
      inc3: "Guia turístico profissional e motorista particular",
      inc4: "Ônibus ou microônibus com ar condicionado",
      inc5: "Apresentações ao vivo e atmosfera musical",
      inc6: "Mercados tradicionais e visitas ao hammam",
      inc7: "Oficinas de culinária e arte",
      inc8: "Excursões a florestas, nascentes e mirantes",
      inc9: "Visitas com famílias locais",
      inc10: "Surpresas especiais durante a viagem"
    },
    pageTitle: "Passeios e Pacotes",
    pageSubtitle: "Escolha um dos nossos pacotes turísticos cuidadosamente selecionados para o Marrocos",
    sectionTitle: "Nossos pacotes turísticos",
    sectionIntro: "De aventuras no deserto a escapadas costeiras, temos o pacote perfeito para cada viajante",
    howToBook: "Como reservar",
    step1Title: "Escolha um passeio",
    step1Text: "Navegue pelos nossos pacotes e selecione o que mais combina com você",
    step2Title: "Clique em Reservar agora",
    step2Text: "Clique no botão \"Reservar agora\" no passeio escolhido",
    step3Title: "Preencher detalhes",
    step3Text: "Forneça suas datas de viagem e informações pessoais",
    step4Title: "Confirmação",
    step4Text: "Receba confirmação e detalhes do itinerário por e-mail",
    customTitle: "Precisa de um pacote personalizado?",
    customText: "Contate-nos para criar uma experiência turística personalizada em Marrocos",
    customBtn: "Entre em contato",
    days: "Dias",
    highlights: "Destaques:",
    bookNow: "Reserve agora",
    highlightsLabel: "DESTAQUES:",
    viewFullDetails: "Ver detalhes completos",
    viewDetails: "Ver detalhes",
    premiumPackage: "Pacote Premium",
    arrival: "Chegada:",
    route: "Rota:",
    flights: "Voos:",
    transportation: "Transporte:",
    hotels: "Hotéis:",
    foodDining: "Comida e jantar:",
    whatsIncluded: "O que está incluído:",
    attractionsExperiences: "Atrações e Experiências:",
    itinerary: "Itinerário:",
    optionalExperiences: "Experiências opcionais:",
    availableUponRequest: "Disponível mediante solicitação:",
    specialSaharaExperience: "Experiência Especial no Saara:",
    suitableFor: "Adequado para:",
    importantNotes: "Notas importantes:",
    priceInformation: "Informações sobre preços:",
    priceWarningText: "Os preços podem mudar dependendo dos preços dos voos, taxas de câmbio, feriados, temporadas e disponibilidade do hotel.",
    safetyComfort: "Segurança e conforto:",
    safetyText: "Trabalhamos em coordenação com as autoridades marroquinas e serviços de segurança para garantir a segurança e o conforto dos nossos hóspedes.",
    safetyTextBrief: "Coordenado com as autoridades marroquinas para sua segurança.",
    givesMore: "Marrocos te ama dá mais:",
    givesMoreText: "Mais amor, carinho, profissionalismo, alegria e segurança. Passeios fáceis e relaxantes com verdadeira hospitalidade humana.",
    givesMoreBrief: "Marrocos ama você:",
    givesMoreTextBrief: "Mais amor, carinho e profissionalismo.",
    bookThisPackage: "Reserve este pacote",
    backToPackages: "Voltar para Pacotes",
    premiumMoroccoPackages: "Pacotes Premium Marrocos",
    premiumMoroccoPackagesDesc: "Experiências exclusivas e cuidadosamente selecionadas para nossos hóspedes mais exigentes.",
    suitable: {
      couples: "Casais",
      families: "Famílias",
      groups: "Grupos",
      solo: "Viajantes individuais",
      seniors: "Idosos",
      companies: "Empresas",
      agencies: "Agências de viagens",
      operators: "Operadores turísticos"
    },
    pkg4: {
      title: "EXPERIÊNCIA DE LUXO NO MARROCOS",
      duration: "16 noites / 17 dias",
      price: "Tudo Incluído",
      hl1: "Casablanca • Rabat • Fez • Tânger • Chefchaouen",
      hl2: "Ifrane • Deserto Merzouga do Saara",
      hl3: "Essaouira • Ourika e montanhas do Atlas • Marraquexe",
      hl3_brief: "Visite as montanhas do Atlas",
      hl4: "2 noites de acampamento de luxo no deserto com passeios de camelo e jipe",
      hl5: "Nascer e pôr do sol mágicos • Durma sob as estrelas",
      subtitle: "✨ Experiência Marrocos Imperial e Saara - A Jornada Completa (16 Noites / 17 Dias)",
      routeText: "Casablanca (1 noite), Rabat, Fez (2 noites), Tânger (1 noite), Chefchaouen (1 noite), Ifrane (1 noite), Merzouga Sahara (2 noites), Essaouira (2 noites), Ourika e Montanhas Atlas (1 noite), Marraquexe (3 noites)",
      inc1: "4★ / 5★ Hotéis",
      inc2: "Acampamento de luxo no deserto com ar condicionado",
      inc2_brief: "Hotéis de 4 a 5 estrelas",
      inc3: "Pensão Completa / Cozinha Marroquina Premium",
      inc3_brief: "Guia turístico profissional",
      inc4: "Guias profissionais multilíngues",
      inc4_brief: "Apresentações especiais ao vivo",
      inc5: "Transporte Privado Moderno",
      inc5_brief: "Mercados tradicionais",
      inc6: "Ônibus com ar condicionado",
      inc7: "Wi-Fi • TV • Geladeira a bordo",
      inc8: "Motorista particular durante todo o passeio",
      inc9: "Passeios de camelo",
      inc10: "Experiência no deserto de jipe",
      inc11: "Shows folclóricos e música ao vivo",
      inc12: "Apresentações de dança marroquina",
      inc13: "Oficinas de Culinária",
      inc14: "Experiências em mercados e souks",
      inc15: "Tapetes • Especiarias • Flores • Artesanato Tradicional",
      inc16: "Lagos • Rios • Montanhas do Atlas",
      inc17: "Experiências especiais ao nascer e pôr do sol",
      inc18: "Suporte direto 24 horas por dia, 7 dias por semana",
      optional1: "Experiência de balão de ar quente",
      optional2: "Atualizações VIP",
      optional3: "Experiências de luxo",
      optional4: "Serviços de segurança privada",
      optional5: "Serviços de Assistência Médica",
      optionalNote: "Alguns serviços premium podem exigir um suplemento justo adicional.",
      sahara1: "Tendas premium no deserto com ar condicionado",
      sahara2: "Atmosfera musical de fogueira",
      sahara3_brief: "Excursões de jipe e passeios de camelo",
      itinerary1: "Casablanca - Chegada (1 Noite)",
      itinerary2: "Rabat - a capital real",
      itinerary3: "Fez - Marrocos Espiritual e Cultural (2 Noites)",
      itinerary4: "Tânger - Onde a Europa encontra a África (1 noite)",
      itinerary5: "Chefchaouen - A Pérola Azul (1 Noite)",
      itinerary6: "Ifrane - A Suíça Marroquina (1 Noite)",
      itinerary7: "Deserto Merzouga Sahara (2 noites) - Acampamento de luxo no deserto - Experiência de camelo - Passeios de jipe - Nascer e pôr do sol mágicos - Dormir sob as estrelas",
      itinerary8: "Essaouira - Fuga do Oceano Atlântico (2 Noites)",
      itinerary9: "Ourika e montanhas do Atlas (1 noite)",
      itinerary10: "Marraquexe - A Cidade Vermelha (3 Noites)"
    }
  },
  tourMini: {
    years: "2026 - 2027",
    days: "10 DIAS",
    nights: "/ 9 NOITES",
    title: "MARROCOS PREMIUM\nTOUR",
    departures: "SAÍDAS MENSAIS",
    allIncluded: "TUDO INCLUÍDO\nPENSÃO COMPLETA",
    recommendations: "Recomendações",
    recCount: "Mais de 500 viajantes felizes"
  },
  testimonials_data: {
    testi1: {
      image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330",
      name: "Sarah Johnson",
      title: "Londres, Reino Unido",
      text: "Marrocos ama você tornou a viagem dos meus sonhos uma realidade! Cada detalhe foi perfeitamente organizado, desde hotéis luxuosos até experiências autênticas. O serviço é incomparável. Já estou planejando minha visita de retorno!",
      rating: 5
    },
    testi2: {
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d",
      name: "Michael Chen",
      title: "Singapura",
      text: "Como viajante de negócios, fiquei impressionado com o profissionalismo e a personalização. Tratamento VIP desde o primeiro dia, roteiro personalizado e logística impecável. Altamente recomendado para viagens executivas.",
      rating: 5
    },
    testi3: {
      image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80",
      name: "Emma Wilson",
      title: "Sydney, Austrália",
      text: "A experiência no deserto foi mágica! Dormir sob as estrelas, fazer passeios de camelo e o calor da hospitalidade marroquina superaram todas as expectativas. Obrigado por criar memórias para toda a vida!",
      rating: 5
    },
    testi4: {
      image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e",
      name: "James Rodríguez",
      title: "Madri, Espanha",
      text: "O planejamento de viagens em família pode ser estressante, mas Marrocos ama você lidou com tudo de maneira brilhante. Seguro, educativo e divertido para todas as idades. Nossos filhos ainda falam sobre as visitas à medina!",
      rating: 5
    },
    testi5: {
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d",
      name: "Anna Müller",
      title: "Berlim, Alemanha",
      text: "Apreciei a autenticidade cultural e o respeito demonstrado pelas tradições locais. Não se tratava apenas de turismo; foi uma verdadeira imersão cultural. Bravo para toda a equipe!",
      rating: 5
    },
    testi6: {
      image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e",
      name: "David Thompson",
      title: "Toronto, Canadá",
      text: "A acessibilidade para idosos foi excepcional. Um ritmo confortável, guias de apoio e acomodações luxuosas deixaram meus avós incrivelmente felizes. Um serviço que realmente se preocupa.",
      rating: 5
    },
    testi7: {
      image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80",
      name: "Lisa Anderson",
      title: "Nova York, EUA",
      text: "Amante de comida aqui! As experiências culinárias foram requintadas. Cada refeição contava uma história, cada guia demonstrava paixão genuína. Os sabores de Marrocos ficarão comigo para sempre.",
      rating: 5
    },
    testi8: {
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d",
      name: "Marcus Smith",
      title: "Los Angeles, EUA",
      text: "Cheio de aventura, mas luxuoso – exatamente o que eu procurava. Trekking no Atlas, safaris no deserto, tudo com conforto VIP. Vale cada centavo!",
      rating: 5
    },
    testi9: {
      image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330",
      name: "Sophie Laurent",
      title: "Paris, França",
      text: "Viagem romântica extraordinária! Pôr do sol no Saara, jantares privados com vista para Marrakech e serviço atencioso por toda parte. Marrocos ama você realmente faz jus ao seu nome.",
      rating: 5
    },
    intro: "Conheça nossos hóspedes satisfeitos que conheceram Marrocos através de nossos serviços"
  },
  stats: {
    happyTravelers: "5000+",
    yearsExperience: "15+",
    destinationsCount: "25+",
    satisfactionRate: "98%"
  },
  nav: {
    home: "Página inicial",
    about: "Sobre nós",
    destinations: "Destinos",
    tours: "Passeios e Pacotes",
    gallery: "Galeria",
    testimonials: "Depoimentos",
    blog: "Blogue",
    contact: "Contate-nos",
    experiences: "Experiências",
    vip: "Negócios VIP",
    vipFull: "Viagens de negócios VIP",
    worldcup: "Copa do Mundo 2030",
    careers: "Carreiras",
    chatWhatsApp: "Converse no WhatsApp",
    jewishHeritage: "Viagem Kosher",
    menu: "Cardápio"
  },
  hero: {
    welcome: "Bem-vindo ao Marrocos.",
    welcomeHome: "Bem-vindo ao lar.",
    subtitle: "Passeios privados de luxo, experiências autênticas,",
    subtitleLine2: "e serviço personalizado completo em Marrocos —",
    subtitleGold: "pessoalmente pelo CEO.",
    whatsappBtn: "Converse com Ilan (CEO) agora no WhatsApp",
    badgeFast: "Resposta rápida",
    badgePersonal: "Atendimento personalizado",
    badge247: "Disponibilidade 24 horas por dia, 7 dias por semana",
    limitedAvail: "Disponibilidade limitada",
    personalizedOnly: "Apenas viagens personalizadas"
  },
  strip: {
    privateTours: "Passeios Privados",
    localExperts: "Especialistas locais",
    bestHotels: "Melhores hotéis",
    luxuryTransport: "Transporte de Luxo",
    satisfaction: "100% de satisfação"
  },
  cta: {
    whatsapp: "Converse com Ilan (CEO) agora no WhatsApp",
    whatsappFloating: "Converse no WhatsApp",
    whatsappInquiry: "Olá, estou interessado em uma experiência de viagem premium no Marrocos."
  },
  home: {
    vipBannerTitle: "Experiências de viagem VIP em Marrocos",
    vipBannerText: "Acesso exclusivo, motoristas particulares e acomodações luxuosas sob medida para viajantes exigentes.",
    vipBannerBtn: "Descubra os serviços VIP",
    wcBadge: "🇲🇦 Copa do Mundo de Marrocos 2030",
    wcTitle: "Marrocos 2030",
    wcText: "Pacotes de viagens exclusivos para a Copa do Mundo que combinam futebol, cultura marroquina, hospitalidade VIP e experiências de luxo.",
    wcBtn: "Ver Pacotes",
    galleryTitle: "Galeria",
    gallerySubtitle: "Um vislumbre da sua futura viagem marroquina",
    exploreDestination: "Explorar destino",
    featuredToursTitle: "Passeios e pacotes em destaque",
    featuredToursSubtitle: "Experiências cuidadosamente selecionadas para a aventura marroquina perfeita",
    viewAllTours: "Ver todos os passeios",
    culinaryTitle: "Nossa comida - a melhor do mundo",
    culinarySubtitle: "Experimente a excelência culinária marroquina 🍲",
    culinaryBtn: "Descubra experiências culinárias",
    culinaryIntro: "No Morocco Loves You, jantar não é apenas comer. É uma viagem ao coração da cultura marroquina. Oferecemos experiências culinárias autênticas e escolhidas a dedo – desde refeições caseiras tradicionais até gastronomia marroquina de alta qualidade, tudo preparado com amor e com os ingredientes locais mais frescos.",
    culinaryVideoTitle: "Vídeos de experiências culinárias",
    culinaryFeatures: [
      "Tagines Tradicionais",
      "Cuscuz Autêntico",
      "Doces Marroquinos",
      "Cerimônias de Chá",
      "Aulas de culinária",
      "Especiarias locais",
      "Ingredientes Orgânicos",
      "Refeições caseiras"
    ],
    videoTitle: "RECOMENDAÇÕES",
    unityQuote: "Marrocos ama você acolhe todas as culturas, todas as crenças e todos os povos.",
    unityAlt: "Marrocos te ama Banner da unidade",
    testimonialsTitle: "O que dizem nossos convidados VIP",
    testimonialsSubtitle: "Avaliações reais de viajantes internacionais",
    readMoreReviews: "Leia mais comentários",
    viewAllTransport: "Ver todos os transportes",
    transportTitle: "Nossos transportes e motoristas VIP",
    transportSubtitle: "Luxo, conforto e segurança em Marrocos 🌍",
    transportIntro: "No Morocco Loves You, o transporte não consiste apenas em ir de um lugar para outro. Faz parte da experiência. Fornecemos veículos modernos, limpos, confortáveis ​​e totalmente climatizados em todo Marrocos – com motoristas profissionais, hospitalidade calorosa e serviço VIP desde o primeiro momento."
  },
  destinations: {
    pageTitle: "Explore os destinos de Marrocos",
    pageSubtitle: "Descubra lugares incríveis para visitar no belo Marrocos",
    sectionTitle: "Todos os destinos",
    sectionIntro: "Marrocos é um país de diversas paisagens e rico património cultural. Explore nossos destinos cuidadosamente selecionados:",
    exploreNow: "Explorar agora",
    ctaTitle: "Pronto para planejar sua viagem?",
    ctaText: "Navegue por nossos passeios e pacotes selecionados para encontrar a experiência marroquina perfeita",
    ctaBtn: "Ver Passeios e Pacotes"
  },
  experiences: {
    pageTitle: "Excelência Culinária Marroquina",
    pageSubtitle: "Descubra a nossa comida – a melhor do mundo",
    bookViaWhatsApp: "Reserve pelo WhatsApp",
    introTitle: "Nossa experiência culinária marroquina única",
    introHighlight: "Sabores autênticos, ingredientes frescos, séculos de tradição e hospitalidade inesquecível.",
    introP1: "Bem-vindo aos sabores autênticos de Marrocos.",
    introP2: "No Morocco Loves You, a comida não é apenas uma refeição - é cultura, história, família, hospitalidade e amor.",
    introP3: "Durante séculos, a culinária marroquina foi considerada uma das cozinhas mais ricas, saudáveis e saborosas do mundo.",
    introP4: "Nossas tradições culinárias combinam influências árabes, berberes, judaicas marroquinas, andaluzas, mediterrâneas e africanas – criando receitas únicas preservadas por mais de 500 anos.",
    prepTitle: "A arte da preparação marroquina",
    prepP1: "Tudo é preparado com cuidado, paixão, ingredientes locais frescos e autênticas especiarias marroquinas.",
    prepP2: "Selecionamos cuidadosamente restaurantes confiáveis, experiências locais autênticas e destinos culinários de qualidade para nossos hóspedes.",
    prepP3: "Marrocos é conhecido mundialmente pelos seus mercados coloridos, agricultura fresca, produtos naturais, especiarias, azeitonas, laranjas, pastelaria, chá de menta e hospitalidade inesquecível.",
    journeyVideos: "Vídeos de jornada culinária",
    highlightsTitle: "Destaques Culinários Tradicionais",
    highlightTagine: "Tagine marroquino autêntico",
    highlightCouscous: "Cuscuz Tradicional",
    highlightVegetables: "Legumes frescos e ingredientes naturais",
    highlightPastries: "Doces e sobremesas caseiras",
    highlightBreakfasts: "Pequenos-almoços marroquinos tradicionais",
    highlightMeat: "Peixe fresco e carnes de qualidade",
    highlightJuices: "Sucos naturais e chá marroquino",
    highlightHealthy: "Tradições culinárias saudáveis e deliciosas",
    galleryTitle: "Nossa Galeria Culinária",
    summaryP1: "Nosso objetivo é oferecer aos nossos hóspedes não apenas uma viagem, mas uma verdadeira viagem culinária marroquina.",
    tagHealthy: "Saudável",
    tagAuthentic: "Autêntico",
    tagTraditional: "Tradicional",
    tagFresh: "Fresco",
    tagUnique: "Único",
    tagDelicious: "Delicioso",
    important: "Importante:",
    guidanceNote: "Para a melhor experiência culinária, recomendamos fortemente seguir as orientações de nossa equipe e as recomendações culinárias durante sua viagem por Marrocos.",
    whereMeal: "Onde cada refeição se torna uma lembrança.",
    whatsappLabel: "WhatsApp: +972 54-633-8757",
    moroccoLine: "Linha Marrocos: +212 6 63 63 05 79"
  },
  vip: {
    pageTitle: "VIP e viagens de negócios",
    pageSubtitle: "Serviços exclusivos para CEOs, investidores e viajantes exigentes",
    introTitle: "Excelência Perfeita em Marrocos",
    introText: "MoroccoLovesYou oferece um padrão de serviço incomparável para viajantes de negócios, delegações corporativas e convidados VIP. Entendemos que seu tempo é valioso e seus padrões são inflexíveis. Do pouso à partida, cuidamos de cada detalhe com precisão, permitindo que você se concentre nos objetivos do seu negócio enquanto proporcionamos uma experiência marroquina impecável.",
    ctaTitle: "Acesso direto ao CEO",
    ctaText: "Para consultas urgentes e solicitações altamente especializadas, fale diretamente com nosso Fundador e CEO, Ilan Hatchuel.",
    ctaBtn: "Entre em contato com Ilan agora",
    luxuryTransport: "Transporte de Luxo",
    luxuryTransportDesc: "Traslados VIP para o aeroporto e motoristas particulares bilíngues disponíveis 24 horas por dia, 7 dias por semana, em veículos de luxo (Mercedes Classe S, Classe V).",
    premiumAccom: "Acomodações Premium",
    premiumAccomDesc: "Reservas exclusivas em hotéis 5 estrelas, riads de luxo ou vilas privadas adequadas para executivos e suas equipes.",
    businessConcierge: "Concierge Empresarial",
    businessConciergeDesc: "Assistência completa para reuniões, reservas de jantares privativos e roteiros especializados para retiros corporativos.",
    securityPrivacy: "Segurança e privacidade",
    securityPrivacyDesc: "Serviço discreto, ambientes seguros e confidencialidade absoluta para personalidades e celebridades importantes.",
    support247: "Suporte 24 horas por dia, 7 dias por semana",
    support247Desc: "Contato direto com o CEO e uma equipe dedicada e pronta para atendê-lo a qualquer momento durante sua estadia.",
    customItineraries: "Itinerários personalizados",
    customItinerariesDesc: "Planos de viagem personalizados equilibrando perfeitamente suas obrigações comerciais com experiências culturais marroquinas premium."
  },
  worldcup: {
    pageTitle: "Copa do Mundo Marrocos 2030",
    pageSubtitle: "Pacotes VIP exclusivos e experiências de viagem para o maior evento de futebol",
    limitedBadge: "Disponibilidade Limitada",
    introTitle: "A jornada definitiva do futebol",
    introText: "Em 2030, Marrocos será co-anfitrião do Campeonato do Mundo da FIFA, trazendo o evento desportivo mais prestigiado do mundo para o Norte de África. MoroccoLovesYou tem orgulho de oferecer pacotes de viagens de luxo exclusivos e com tudo incluído, projetados para fãs que exigem o melhor em conforto, acesso e experiência.",
    packagesTitle: "Pacotes Premium da Copa do Mundo",
    silverTitle: "Pacote Prata",
    silverSub: "A experiência essencial",
    goldTitle: "Pacote Ouro",
    goldSub: "A experiência de luxo",
    mostPopular: "Mais populares",
    diamondTitle: "Diamante VIP",
    diamondSub: "A experiência definitiva",
    inquireWhatsApp: "Consulte pelo WhatsApp",
    ctaTitle: "Garanta seu lugar antes que os preços subam",
    ctaText: "Devido à demanda internacional extremamente alta, é altamente recomendável garantir seu pacote VIP com antecedência. As acomodações nas cidades-sede estarão esgotadas.",
    ctaBtn: "Contate-nos hoje",
    silverF1: "Riad Premium / Alojamento em Hotel de 4 Estrelas",
    silverF2: "Logística pré-planejada para o dia do jogo",
    silverF3: "City Tours Guiados (Cidades Sede)",
    silverF4: "Linha de suporte dedicada 24 horas por dia, 7 dias por semana",
    goldF1: "Hotel 5 estrelas/acomodação em villa de luxo",
    goldF2: "Aeroporto privado e transferências de jogos",
    goldF3: "Escapadinha VIP no acampamento no deserto (2 dias)",
    goldF4: "Concierge pessoal bilíngue",
    diamondF1: "Suítes Presidenciais / Palácios Privados",
    diamondF2: "Motorista particular e segurança 24 horas por dia, 7 dias por semana",
    diamondF3: "Acesso exclusivo a eventos e festas VIP",
    diamondF4: "Atendimento direto ao CEO e concierge VVIP"
  },
  gallery: {
    pageTitle: "Nossa Galeria",
    pageSubtitle: "Memórias visuais de viagens inesquecíveis ao Marrocos",
    picturesTitle: "Marrocos em fotos",
    picturesIntro: "Explore nossa coleção de fotos de tirar o fôlego do Marrocos",
    videosTitle: "Marrocos em movimento",
    videosIntro: "Experimente Marrocos através da nossa coleção de vídeos com curadoria",
    catFood: "Experiência Culinária",
    catDestinations: "Destinos",
    catKosher: "Kosher",
    catTransport: "Transporte VIP"
  },
  testimonials: {
    pageTitle: "Depoimentos de convidados",
    pageSubtitle: "Leia o que nossos viajantes têm a dizer sobre sua experiência marroquina",
    sectionTitle: "Nossos felizes viajantes",
    sectionIntro: "Milhares de hóspedes satisfeitos experimentaram connosco a magia de Marrocos",
    verifiedGuest: "Convidado verificado",
    ratingsTitle: "Nossas classificações",
    avgRating: "Avaliação média",
    verifiedReviews: "Avaliações verificadas",
    fromReal: "De viajantes reais",
    custSatisfaction: "Satisfação do Cliente",
    wouldRecommend: "Recomendaria",
    shareTitle: "Compartilhe sua experiência",
    shareText: "Teve uma viagem incrível conosco? Adoraríamos ouvir sobre isso!",
    shareBtn: "Conte-nos sua história"
  },
  blog: {
    pageTitle: "Blog de viagens",
    pageSubtitle: "Histórias, dicas e guias para sua aventura marroquina",
    sectionTitle: "Últimos artigos de viagens",
    sectionIntro: "Leia nossos artigos mais recentes sobre viagens em Marrocos, cultura local e dicas privilegiadas",
    readMore: "Leia mais →",
    by: "Por",
    newsletterTitle: "Assine nosso boletim informativo",
    newsletterText: "Receba as últimas dicas de viagem e ofertas exclusivas em sua caixa de entrada",
    newsletterPlaceholder: "Digite seu e-mail",
    subscribe: "Inscrever-se"
  },
  contact: {
    pageTitle: "Contate-nos 24 horas por dia, 7 dias por semana",
    pageSubtitle: "Entre em contato com nossa equipe para planejar sua aventura VIP no Marrocos",
    getInTouch: "Contate-nos",
    getInTouchText: "Estamos aqui para ajudar e responder a qualquer dúvida que você possa ter. Nossa equipe está pronta para ajudá-lo a planejar sua viagem perfeita ao Marrocos.",
    address: "Nosso endereço",
    addressText: "Rua Mohammed V, 53, Fes, Marrocos",
    phone: "Números de telefone 📞",
    directPhone: "Telefone direto: +212 6 63 63 05 79",
    whatsappPhone: "WhatsApp: +972 54 633 8757",
    email: "Endereços de e-mail profissionais",
    emailList: [
      "CEO@MoroccoLovesYou.com",
      "Info@MoroccoLovesYou.com",
      "Vendas@MarrocosLovesYou.com",
      "Michael@MoroccoLovesYou.com",
      "Kim@MoroccoLovesYou.com"
    ],
    businessHours: "Horário comercial",
    businessHoursText: "Disponível 24 horas por dia, 7 dias por semana\n7 dias por semana",
    responseTime: "Entraremos em contato com você dentro de 48 horas.",
    welcomeMessage: "Bem vindo ao Marrocos 🇲🇦",
    followUs: "Siga-nos",
    formTitle: "Envie-nos uma mensagem",
    successMessage: "✓ Obrigado! Entraremos em contato com você em breve.",
    firstName: "Primeiro nome",
    lastName: "Sobrenome",
    emailAddress: "Endereço de e-mail",
    phoneNumber: "Número de telefone",
    subject: "Assunto",
    selectSubject: "Selecione um assunto",
    tourInquiry: "Consulta de passeio",
    bookingQuestion: "Pergunta de reserva",
    customPackage: "Pacote personalizado",
    feedback: "Comentários",
    other: "Outro",
    message: "Detalhes/Mensagem",
    sendMessage: "Enviar mensagem",
    mapTitle: "Encontre-nos no mapa",
    faqTitle: "Perguntas frequentes",
    faq1Q: "Qual é a melhor época para visitar Marrocos?",
    faq1A: "A primavera (abril-maio) e o outono (setembro-outubro) oferecem o melhor clima. O verão é quente no deserto, enquanto o inverno é ameno, mas pode ser chuvoso.",
    faq2Q: "Preciso de visto para visitar Marrocos?",
    faq2A: "Os requisitos de visto dependem da sua nacionalidade. Muitos países têm entrada sem visto por até 90 dias. Verifique com sua embaixada local.",
    faq3Q: "Que moeda é usada em Marrocos?",
    faq3A: "O Dirham Marroquino (MAD) é a moeda oficial. Os caixas eletrônicos estão amplamente disponíveis nas cidades e a maioria dos lugares aceita cartões de crédito.",
    faq4Q: "Que língua é falada em Marrocos?",
    faq4A: "Árabe e berbere (Amazigh) são línguas oficiais. O francês é amplamente falado e o inglês é cada vez mais comum nas áreas turísticas.",
    faq5Q: "Marrocos é seguro para turistas?",
    faq5A: "Sim, Marrocos é geralmente seguro para turistas. Aplicam-se precauções de bom senso. Nossos guias garantem que você tenha uma experiência segura e agradável.",
    faq6Q: "Posso personalizar meu pacote turístico?",
    faq6A: "Absolutamente! Oferecemos pacotes personalizados adaptados aos seus interesses, orçamento e datas de viagem. Entre em contato conosco para discutir suas necessidades."
  },
  about: {
    pageTitle: "Sobre MarrocosLovesYou",
    pageSubtitle: "O seu parceiro de confiança para descobrir a magia de Marrocos",
    storyTitle: "Nossa história",
    storyP1: "MoroccoLovesYou foi fundada com uma missão simples: ajudar os viajantes a vivenciar a autêntica beleza, cultura e hospitalidade de Marrocos. O que começou como um pequeno serviço de guia de viagens tornou-se uma empresa de turismo abrangente que atende milhares de visitantes anualmente.",
    storyP2: "A nossa fundadora, Fatima Hassan, apaixonou-se por Marrocos e quis partilhar esta paixão com o mundo. Hoje, orgulhamo-nos de criar experiências personalizadas e autênticas que vão além do turismo típico.",
    missionTitle: "🎯 Nossa Missão",
    missionText: "Proporcionar experiências de viagem excepcionais que mostrem a rica herança cultural de Marrocos, as paisagens deslumbrantes e a hospitalidade calorosa, ao mesmo tempo que apoiam as comunidades locais e as práticas de turismo sustentável.",
    visionTitle: "🌟 Nossa Visão",
    visionText: "Ser a empresa líder de turismo em Marrocos, conhecida pela autenticidade, confiabilidade e pela criação de memórias inesquecíveis para todos os viajantes que optam por explorar este magnífico país conosco.",
    whyTitle: "Por que escolher MarrocosLovesYou?",
    expertTitle: "Conhecimento especializado",
    expertText: "Nossa equipe possui amplo conhecimento de Marrocos e fornece recomendações personalizadas.",
    localTitle: "Conexões locais",
    localText: "Trabalhamos com guias locais autênticos e famílias para garantir experiências genuínas.",
    valueTitle: "Melhor valor",
    valueText: "Preços competitivos sem comprometer a qualidade e a experiência.",
    safetyTitle: "Segurança e suporte",
    safetyText: "Suporte ao cliente 24 horas por dia, 7 dias por semana e seguro de viagem abrangente incluído.",
    sustainTitle: "Turismo Sustentável",
    sustainText: "Apoiamos as comunidades locais e praticamos turismo responsável.",
    bookingTitle: "Reserva Fácil",
    bookingText: "Processo simples de reserva online com opções de pagamento flexíveis.",
    teamTitle: "Nossa equipe",
    teamSubtitle: "Conheça as pessoas apaixonadas por trás de MoroccoLovesYou",
    happyTravelers: "Viajantes felizes",
    yearsExp: "Anos de experiência",
    destinationsCount: "Destinos",
    satisfactionRate: "Taxa de satisfação"
  },
  footer: {
    description: "Descubra a magia de Marrocos connosco. Experimente aventuras inesquecíveis e crie memórias duradouras.",
    quickLinks: "Links rápidos",
    more: "Mais",
    contactInfo: "Informações de contato",
    copyright: "© 2024 MarrocosLovesYou. Todos os direitos reservados."
  },
  starBanner: {
    ceoMessage: "MENSAGEM DO CEO",
    watchVideo: "Assista meu vídeo",
    readMessage: "& leia minha mensagem",
    getToKnow: "Conheça",
    ilanPersonally: "Ilan pessoalmente"
  },
  cityDetail: {
    notFound: "Cidade não encontrada",
    backHome: "De volta para casa",
    discoverSubtitle: "Descubra a beleza e a cultura",
    planTrip: "Planeje minha viagem para",
    galleryOf: "Galeria de",
    bookExperience: "Reserve esta experiência",
    requestItinerary: "Solicite Itinerário Completo",
    readyToVisit: "Pronto para visitar",
    readyToVisitText: "Deixe-nos planejar sua viagem perfeita para este destino incrível",
    planMyTrip: "Planeje minha viagem",
    talkExpert: "Fale com um especialista"
  },
  transportation: {
    pageTitle: "Transporte VIP e Motoristas",
    pageSubtitle: "Luxo, conforto e segurança em Marrocos",
    introTitle: "Nossos transportes e motoristas VIP",
    introP1: "No Morocco Loves You, o transporte não consiste apenas em ir de um lugar para outro.",
    introP2: "Faz parte da experiência.",
    introP3: "Fornecemos veículos modernos, limpos, confortáveis ​​e totalmente climatizados em todo Marrocos – com motoristas profissionais, hospitalidade calorosa e serviço VIP desde o primeiro momento.",
    introP4: "Quer você viaje em casal, em família, em delegação de negócios ou em grupo privado, garantimos que sua viagem seja segura, relaxante e inesquecível.",
    servicesTitle: "Nossos serviços de transporte incluem",
    servicesList: [
      "Ônibus VIP modernos",
      "Microônibus de luxo",
      "Carros particulares",
      "Jipes 4x4 para aventuras no deserto",
      "Limusines VIP",
      "Recolha e entrega no aeroporto",
      "Motoristas profissionais multilíngues",
      "Ar condicionado confortável",
      "Veículos limpos e organizados",
      "Geladeiras em veículos selecionados",
      "Sistemas de TV e entretenimento",
      "Música durante a viagem",
      "Condução segura e suave",
      "Assistência 24 horas por dia, 7 dias por semana em Marrocos"
    ],
    featureList: [
      "Ônibus VIP modernos",
      "Microônibus de luxo",
      "Carros particulares",
      "Jipes 4x4",
      "Recolha no aeroporto",
      "Drivers multilíngues",
      "Assistência 24 horas por dia, 7 dias por semana",
      "Condução segura"
    ],
    driversTitle: "Conheça nossos motoristas",
    driversText1: "Nossos motoristas fazem parte da família Morocco Loves You.",
    driversText2: "Profissional, respeitoso, experiente e sempre pronto para ajudar com um sorriso.",
    driversText3: "Muitos de nossos motoristas falam vários idiomas e conhecem Marrocos profundamente, ajudando nossos hóspedes a se sentirem confortáveis, seguros e conectados durante toda a viagem.",
    safetyTitle: "Segurança e conforto em primeiro lugar",
    safetyText1: "Seu conforto e segurança são nossas principais prioridades.",
    safetyText2: "Todos os veículos são regularmente mantidos, limpos e cuidadosamente preparados antes de cada viagem.",
    safetyText3: "Trabalhamos apenas com motoristas profissionais de confiança e parceiros de transporte de alta qualidade.",
    categories: {
      buses: "Ônibus VIP",
      minibuses: "Microônibus de luxo",
      cars: "Carros particulares e transferências VIP",
      jeeps: "Jipes 4x4 e transporte no deserto",
      meetDrivers: "Conheça nossos motoristas",
      videos: "Vídeos de experiência de transporte"
    },
    videoGalleryTitle: "Vídeos de experiência VIP",
    ctaTitle: "Pronto para explorar Marrocos com conforto?",
    ctaSubtitle: "Fale diretamente com Allan – CEO e fundador",
    whatsapp: "WhatsApp: +972546338757",
    moroccoLine: "Linha direta de Marrocos: +212 6 63 63 05 79"
  },
  jewishHeritage: {
    pageTitle: "Passeios Kosher de luxo em Marrocos",
    pageSubtitle: "Herança Judaica Autêntica, Cozinha 100% Kosher, Hospitalidade de Luxo e Experiências Únicas no Marrocos.",
    introTitle: "Experiência luxuosa da herança judaica",
    introHeading: "Descubra o autêntico Marrocos judeu",
    introText: "Descubra as raízes profundas da história judaica no Marrocos com uma experiência de viagem elegante, autêntica e premium. Somos especializados em fornecer uma jornada perfeita para comunidades judaicas em todo o mundo, com foco na herança, conexão e conforto absoluto.",
    introQuote: "“Marrocos é uma terra de tolerância e coexistência, onde a herança judaica é preservada com amor e respeito”.",
    experiencesTitle: "Nossas experiências Kosher incluem",
    experiencesList: [
      "Comida e restaurantes 100% Kosher",
      "Chef Kosher Privado Disponível",
      "Cozinha Judaica Marroquina Tradicional",
      "Hotéis luxuosos de 4 e 5 estrelas",
      "Transporte VIP Privado",
      "Guias profissionais multilíngues",
      "Patrimônio Judaico e Passeios pela Sinagoga",
      "Cemitérios e Museus Judaicos",
      "Experiências no Deserto do Saara e Hammam",
      "Assistência Profissional 24 horas por dia, 7 dias por semana"
    ],
    expFood: "Comida 100% Kosher",
    expRestaurant: "Restaurante Kosher",
    expChef: "Chef Kosher Privado Disponível",
    expCuisine: "Cozinha Judaica Marroquina Tradicional",
    expHotels: "Hotéis de luxo 4 e 5 estrelas",
    expDeluxeHotels: "Hotéis de luxo disponíveis mediante solicitação",
    expTransport: "Transporte VIP Privado",
    expDrivers: "Motoristas Profissionais",
    expAC: "Veículos com ar condicionado",
    expWifi: "WiFi, TV e geladeiras em veículos selecionados",
    expGuides: "Guias profissionais multilíngues",
    expStaff: "Pessoal que fala hebraico/inglês/francês/espanhol/russo/alemão",
    expHeritage: "Passeios pela herança judaica",
    expSynagogues: "Sinagogas Antigas",
    expCemeteries: "Cemitérios Judaicos",
    expMuseums: "Museus Judaicos",
    expSpiritual: "Experiências Espirituais e Culturais",
    expDesert: "Experiências no Deserto do Saara",
    expHammam: "Experiências de Hammam Marroquino",
    expAttractions: "Atrações únicas em Marrocos",
    expAssistance: "Assistência 24 horas por dia, 7 dias por semana",
    packagesTitle: "Pacotes de viagem Kosher flexíveis",
    packagesIntro: "Personalizamos cada viagem de acordo com as necessidades, tradições, estilo de viagem, datas e expectativas dos nossos hóspedes.",
    packageOptions: [
      "4–5 dias",
      "7–8 dias",
      "10–11 dias",
      "13–14 dias",
      "21 dias",
      "Passeios privados sob medida"
    ],
    package4_5: "4–5 dias",
    package7_8: "7–8 dias",
    package10_11: "10–11 dias",
    package13_14: "13–14 dias",
    package21: "21 dias",
    packageTailor: "Passeios privados sob medida",
    packagesQuote: "“Personalizamos cada viagem de acordo com as necessidades, tradições, estilo de viagem, datas e expectativas dos nossos hóspedes.”",
    safetyTitle: "Viagem confortável, profissional e segura",
    safetyText: "Nossos passeios operam com grande atenção ao conforto, organização, qualidade de serviço e coordenação profissional em Marrocos.",
    safetyQuote: "“Nossos passeios operam com grande atenção ao conforto, organização, qualidade de serviço e coordenação profissional em Marrocos.”",
    b2bTitle: "Parcerias de viagens judaicas B2B",
    b2bText: "Fazemos parcerias com comunidades judaicas, sinagogas, rabinos e operadores turísticos kosher em todo o mundo para criar viagens históricas significativas.",
    b2bPartnersList: "Trabalhamos com: comunidades judaicas, sinagogas, rabinos, organizações judaicas, operadores turísticos Kosher e agências de viagens em todo o mundo.",
    partnerBtn: "Faça parceria conosco",
    galleryTitle: "Galeria de Experiência Kosher",
    videosTitle: "Vídeos em destaque",
    ctaTitle: "Pronto para começar sua jornada?",
    msgAllan: "Envie uma mensagem para Allan no WhatsApp",
    callMorocco: "Ligue para Marrocos: +212 6 63 63 05 79",
    ceoContact: "Fale com Allan Hatchuel diretamente no WhatsApp",
    exploreBtn: "Explore passeios Kosher"
  },
  aria: {
    selectLanguage: "Selecione o idioma",
    closeDetails: "Fechar detalhes",
    openMenu: "Abrir menu",
    closeMenu: "Fechar menu",
    kosherTravel: "Kosher Travel Marrocos",
    watchVideo: "Assista ao vídeo do Magic Marrocos",
    followInstagram: "Siga-nos no Instagram",
    followFacebook: "Siga-nos no Facebook",
    ceoMessage: "CEO do Marrocos ama você",
    whatsappSocial: "WhatsApp",
    instagramSocial: "Instagram",
    facebookSocial: "Facebook",
    logoAlt: "MarrocosLovesYou logo",
    kingAlt: "Rei de Marrocos",
    kosherOptionsAlt: "Opções kosher",
    moroccoLandscape: "Paisagem de Marrocos",
    worldCupAlt: "Troféu da Copa do Mundo com bandeira marroquina",
    b2bBannerAlt: "Banner de tour somente B2B - clique para WhatsApp",
    starAlt: "Estrela",
    playVideo: "Jogar",
    pauseVideo: "Pausa",
    vipBus: "Ônibus VIP",
    drivers: "Nossos motoristas",
    jewishHeritageArchitecture: "Arquitetura da herança judaica",
    jewishHeritageMorocco: "Herança judaica Marrocos",
    kosherFoodMorocco: "Comida Kosher Marrocos",
    jewishHeritageExperience: "Experiência da herança judaica",
    kosherMoroccanTable: "Mesa marroquina Kosher",
    luxuryHospitality: "Hospitalidade de luxo",
    kosherExperience: "Experiência Kosher"
  },
  forms: {
    firstName: "por exemplo João",
    lastName: "por exemplo Doe",
    email: "nome@exemplo.com",
    subject: "Como podemos ajudar?",
    message: "Conte-nos mais sobre seus planos de viagem...",
    phone: "Seu número de telefone",
    date: "Selecione uma data",
    guests: "Número de convidados"
  },
  common: {
    selectLanguage: "Selecione o idioma",
    instagram: "Instagram",
    facebook: "Facebook",
    loading: "Carregando...",
    error: "Ocorreu um erro",
    success: "Sucesso!",
    noResults: "Nenhum resultado encontrado",
    viewMore: "Ver mais",
    viewLess: "Ver menos",
    bookNow: "Reserve agora",
    learnMore: "Saiba mais",
    contactUs: "Contate-nos",
    close: "Fechar",
    back: "Voltar",
    next: "Próximo",
    previous: "Anterior",
    search: "Pesquisar...",
    filter: "Filtro",
    sort: "Classificar",
    price: "Preço",
    duration: "Duração",
    languages: {
      english: "Inglês",
      american: "americano",
      australia: "Austrália",
      canada: "Canadá",
      french: "Francês",
      spanish: "Espanhol",
      hebrew: "Hebraico",
      arabic: "العربية",
      german: "Alemão",
      italian: "Italiano",
      japanese: "Japonês",
      chinese: "Chinês",
      korean: "Coreano",
      vietnamese: "Vietnamita",
      russian: "Russo",
      en: "Inglês",
      "en-US": "americano",
      "en-AU": "Austrália",
      "en-CA": "Canadá",
      fr: "Francês",
      es: "Espanhol",
      he: "Hebraico",
      ar: "العربية",
      de: "Alemão",
      it: "Italiano",
      ja: "Japonês",
      zh: "Chinês",
      ko: "Coreano",
      vi: "Vietnamita",
      ru: "Russo",
      "pt-PT": "Português (Portugal)"
    }
  },
  whatsapp: {
    greeting: "Olá Marrocos te ama! 🌟",
    bookPackage: "Gostaria de reservar o seguinte pacote:",
    packageInfo: "📦 Pacote: ",
    duration: "⏱️ Duração: ",
    price: "💰 Preço: ",
    bookingRequest: "Por favor, deixe-me saber a disponibilidade e os próximos passos. Obrigado!",
    cityTrip: "Gostaria de planejar uma viagem para {city}. Pode me ajudar?",
    silverPackage: "Estou interessado no Pacote Prata da Copa do Mundo",
    goldPackage: "Estou interessado no Pacote Ouro da Copa do Mundo",
    diamondPackage: "Estou interessado no Pacote VIP Diamond World Cup",
    worldCupSecure: "Olá, quero garantir minha vaga para Marrocos 2030.",
    kosherInquiry: "Estou interessado em seus pacotes de viagem Kosher para Marrocos.",
    customPackage: "Gostaria de criar um pacote personalizado para o nosso grupo.",
    businessInquiry: "Estou interessado em serviços VIP Business Travel."
  },
  blog_posts: {
    post1: {
      title: "10 joias escondidas para descobrir em Marrocos",
      author: "Fátima Hassan",
      date: "15 de março de 2024",
      category: "Guia de viagem",
      excerpt: "Descubra os destinos menos conhecidos e os tesouros escondidos de Marrocos que a maioria dos turistas sente falta. De aldeias secretas nas montanhas a áreas costeiras imaculadas, explore o autêntico Marrocos.",
      content: "Marrocos é muito mais do que apenas Marraquexe e Casablanca. Este guia completo revela joias escondidas..."
    },
    post2: {
      title: "Melhor época para visitar Marrocos: um guia completo",
      author: "Ahmed Bennani",
      date: "10 de março de 2024",
      category: "Planejamento",
      excerpt: "Planejando sua viagem ao Marrocos? Saiba mais sobre as melhores épocas para visitar, o que esperar em termos de clima e como aproveitar ao máximo sua viagem ao longo do ano.",
      content: "Escolher o momento certo para visitar Marrocos pode impactar significativamente a sua experiência de viagem. Aqui está nosso guia completo..."
    },
    post3: {
      title: "Cozinha Marroquina: Uma Aventura Culinária",
      author: "Layla Rahim",
      date: "5 de março de 2024",
      category: "Comida e Cultura",
      excerpt: "Embarque numa viagem culinária por Marrocos. Descubra os sabores ricos, as receitas tradicionais e as experiências gastronômicas que tornam a comida marroquina mundialmente famosa.",
      content: "A culinária marroquina é uma mistura de influências árabes, berberes, andaluzas e africanas. Cada prato conta uma história da herança diversificada de Marrocos..."
    },
    post4: {
      title: "Como pechinchar nos mercados marroquinos como um profissional",
      author: "Youssef Alaoui",
      date: "28 de fevereiro de 2024",
      category: "Dicas de viagem",
      excerpt: "Domine a arte de pechinchar nos souks e mercados marroquinos. Aprenda a etiqueta cultural, táticas de negociação e dicas privilegiadas para conseguir os melhores negócios.",
      content: "A negociação não é apenas uma transação nos mercados marroquinos; é um intercâmbio cultural. Veja como fazer isso de maneira respeitosa e eficaz..."
    },
    post5: {
      title: "Trekking nas montanhas do Atlas: o que você precisa saber",
      author: "Ahmed Bennani",
      date: "20 de fevereiro de 2024",
      category: "Aventura",
      excerpt: "Explore as majestosas montanhas do Atlas a pé. Obtenha conselhos de especialistas sobre rotas de trekking, o que levar na mala, considerações sobre altitude e o melhor horário para sua aventura nas montanhas.",
      content: "As Montanhas Atlas oferecem algumas das paisagens mais deslumbrantes do Norte de África. Seja você um caminhante experiente ou um iniciante..."
    },
    post6: {
      title: "Desert Safari: uma experiência inesquecível",
      author: "Fátima Hassan",
      date: "15 de fevereiro de 2024",
      category: "Aventura",
      excerpt: "Experimente a magia do deserto do Saara em Marrocos. Caminhadas de camelo, noites estreladas sob tendas de lona e momentos do nascer do sol que você nunca esquecerá.",
      content: "O Deserto do Saara representa a alma de Marrocos. Um safari no deserto é mais do que apenas uma aventura; é uma jornada espiritual..."
    },
    post7: {
      title: "Etiqueta Cultural: Respeitando as Tradições Marroquinas",
      author: "Layla Rahim",
      date: "10 de fevereiro de 2024",
      category: "Cultura",
      excerpt: "Aprenda as normas culturais, costumes e etiqueta essenciais para interagir respeitosamente com o povo e as tradições marroquinas durante a sua visita.",
      content: "Compreender e respeitar os costumes locais é crucial quando se viaja para Marrocos. Este guia cobre práticas culturais essenciais..."
    },
    post8: {
      title: "Fotografia em Marrocos: Capturando a Magia",
      author: "Youssef Alaoui",
      date: "5 de fevereiro de 2024",
      category: "Fotografia",
      excerpt: "Descubra os locais mais fotogênicos de Marrocos e dicas profissionais para capturar imagens impressionantes de paisagens, pessoas e cultura.",
      content: "Marrocos é o paraíso dos fotógrafos. Das medinas azuis aos desertos dourados, cada canto oferece oportunidades fotográficas incríveis..."
    }
  },
  jobs: {
    title: "Carreiras e oportunidades",
    intro: "Junte-se à equipe MoroccoLovesYou e construa seu futuro em viagens de luxo",
    workWith: "Trabalhe com Amor, Cuidado e Excelência",
    introText: "Procuramos pessoas apaixonadas e dedicadas que compartilhem nossa visão de oferecer experiências de viagem de classe mundial. Junte-se à nossa equipe em crescimento e faça parte de algo especial.",
    openPositions: "Posições abertas",
    requirements: "Requisitos:",
    readyJoin: "Pronto para se juntar a nós?",
    sendCV: "Envie seu currículo para careers@moroccolovesyou.com",
    instructions: "Inclua uma breve carta explicando por que você gostaria de se juntar à equipe Morocco Loves You.",
    emailCv: "Enviar currículo por e-mail para o CEO",
    chatCeo: "Converse com o CEO no WhatsApp",
    job1: {
      title: "Guia turístico profissional multilíngue",
      type: "Tempo Integral / Sazonal",
      location: "Marrakech / Fez / Marrocos",
      description: "Procuramos guias apaixonados, conhecedores e contadores de histórias que possam dar vida ao Marrocos para nossos convidados VIP. Sua função envolve liderar tours premium, compartilhar insights culturais e garantir a satisfação dos hóspedes.",
      req1: "Fluente em pelo menos 2 idiomas (de preferência francês, espanhol, inglês, hebraico, alemão, russo ou italiano)",
      req2: "Profundo conhecimento da história, cultura e geografia marroquina",
      req3: "Profissional, pessoal e excelentes habilidades de atendimento ao cliente",
      req4: "Aptidão física para caminhadas no deserto e atividades ao ar livre"
    },
    job2: {
      title: "Motorista Executivo VIP",
      type: "Tempo integral",
      location: "Em todo o Marrocos",
      description: "Junte-se à nossa equipe de transporte de luxo dirigindo veículos Mercedes modernos e sofisticados. Você fornecerá transferências VIP, garantirá conforto e segurança aos hóspedes e representará nossa marca com profissionalismo e hospitalidade.",
      req1: "Carteira de motorista válida com excelente histórico de condução (preferencialmente mais de 10 anos de experiência)",
      req2: "Fluência em Inglês (idiomas adicionais são um plus)",
      req3: "Aparência profissional e comportamento cortês",
      req4: "Conhecimento das estradas e rotas de Marrocos; Experiência GPS/navegação"
    },
    job3: {
      title: "Coordenador de Experiência do Cliente",
      type: "Tempo integral",
      location: "Remoto / Híbrido (Escritório de Fes)",
      description: "Apoie nosso escritório de CEO na organização de itinerários personalizados de luxo, gerenciando as comunicações com os hóspedes e garantindo uma coordenação perfeita de viagens. Esta função é ideal para profissionais organizados e detalhistas.",
      req1: "Excelentes habilidades organizacionais e de comunicação",
      req2: "Experiência com viagens, hospitalidade ou atendimento ao cliente",
      req3: "Fluente em Inglês; idiomas adicionais um bônus",
      req4: "Proficiência com sistemas de reservas e pacote Microsoft Office"
    }
  },
  gallery_categories: {
    food: "Experiência Culinária",
    destinations: "Destinos",
    kosher: "Kosher",
    transport: "Transporte VIP"
  }
};

export default ptPT;
